import styled from '@emotion/styled';
import { Flex } from '@chakra-ui/react';

const StyledTaxRegionContainer = styled.div`
  min-height: calc(100vh - 120px);
`;

export const StyledTaxRegionHeaderContainer = styled(Flex)`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
`;

export const StyledTableContainer = styled.div`
  .chakra-table {
    border-collapse: separate;
    border-spacing: 0;

    th {
      background-color: #f7fafc;
      border-bottom: 2px solid #e2e8f0;
      font-weight: 600;
      text-transform: uppercase;
      letter-spacing: 0.05em;
      font-size: 0.875rem;
    }

    td {
      border-bottom: 1px solid #e2e8f0;
      padding: 16px;
    }

    tr:hover {
      background-color: #f7fafc;
    }
  }
`;

export default StyledTaxRegionContainer;
